import { useTranslation } from "react-i18next";
import { SupplierScoreBase, HintConfig } from "./SupplierScoreBase";
import { useIngredientContext } from "../../useIngredientContext";
import { Loading } from "src/components/utils/Loading";

/**
 * Business component for scores without supplier
 * Contains specific logic for no supplier case
 */
export const NoSupplierScore = () => {
    const { t } = useTranslation();
    const { ingredient, scores, areScoresRefetching, ingredientReference, isIngredientReferenceReady } =
        useIngredientContext();

    if (!ingredient) {
        return <Loading />;
    }

    const hintConfig: HintConfig = {
        title: t(
            "les_indicateurs_specifiques_de_cet_ingredient_ne_sont_pas_calcules_car_son_impact_sur_les_produits_l_utilisant_n_est_pas_significatif",
        ),
        content: t("ingredient.nosupplierscore"),
        shouldShow: true,
    };

    return (
        <SupplierScoreBase
            ingredient={ingredient}
            scores={scores}
            areScoresRefetching={areScoresRefetching}
            ingredientReference={ingredientReference}
            isIngredientReferenceReady={isIngredientReferenceReady}
            hintConfig={hintConfig}
            post={undefined}
        />
    );
};
